/* Строка канала: плитка 30px — колонка под неё, как в брони и в переписке. */
.root {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) auto;
  align-items: start;
  gap: 10px;
  padding: 9px 0;
  list-style: none;
}

/* Разделитель МЕЖДУ строками — на верхней границе второй. `:last-child` здесь ненадёжен: после
   списка каналов в карточке идут другие блоки, и «последний» бывает не тем, о ком думаешь. */
.root + .root {
  border-top: 1px solid var(--line-2);
}

.body {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.title {
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 9.5px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--ink-3);
}

/* Длинная почта не распирает колонку — срезается многоточием. */
.value {
  overflow: hidden;
  font-size: 12.5px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Атрибуция — тише значения: она объясняет строку, а не спорит с ней за внимание. */
.source {
  margin-top: 1px;
  color: var(--ink-4);
  font-size: 10.5px;
  line-height: 1.4;
}

/*
 * Чужой канал приглушён целиком — включая плитку. Он ВИДЕН (§2.2 требует показывать все каналы),
 * но всем своим видом сообщает, что это не наша строка: править её нельзя (§2.3), и приглушение
 * говорит это раньше, чем менеджер потянется к кнопке, которой у него нет.
 */
.root[data-foreign='true'] .value {
  color: var(--ink-2);
}

.root[data-foreign='true'] > :first-child {
  opacity: 0.55;
}

.actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
